export enum AUSnackBarTypes {
  Error,
  Success,
  Info
}
